import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query";

const baseQuery = fetchBaseQuery({
  baseUrl: "/",
  prepareHeaders(headers) {
    // fixme: poprawić po testach
    // const token = process.env.REACT_APP_TOKEN;
    // headers.set("Authorization", `Bearer ${token}`);

    return headers;
  },
});

const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  // Check if impersonation token expired
  if (result.error && result.error.status === 403) {
    const errorData = result.error.data as any;
    // NestJS ForbiddenException returns {statusCode, message}
    // wildcardAction returns {error: "..."}
    if (
      errorData?.message === "Impersonation token expired" ||
      errorData?.error === "Impersonation token expired"
    ) {
      // Redirect to dashboard to clear state and go back to original user
      window.location.href = "/pulpit";
      return result;
    }
  }

  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
});
